const getSearchTerm = state => state.facet.searchTerm;

export default getSearchTerm;
